/**
 * Created by wuhuping on 2017/10/27.
 */
import noticeViewComponents from '../components/views/common/xy-notice-view.vue'
import { mergeOptions } from './plugin_helper'
import Vue from 'vue'
let $vm

const plugin = {
  install(vue, options) {
    const NoticeView = vue.extend(noticeViewComponents)

    if (!$vm) {
      $vm = new NoticeView({
        el: document.createElement('div')
      })
      document.body.appendChild($vm.$el)
    }

    const noticeView = {
      show(options = {}) {
        if (typeof options === 'object') {
          mergeOptions($vm, options)
        }
        $vm.show = true
      },
      hide() {
        $vm.show = false
      },
      isShow() {
        return $vm.show
      }
    }

    if (!vue.$xyPlugins) {
      vue.$xyPlugins = {
        noticeView
      }
    } else {
      vue.$xyPlugins.noticeView = noticeView
    }

    vue.mixin({
      created: function () {
        this.$xyPlugins = vue.$xyPlugins
      }
    })
  },
  uninstall() {
    if ($vm.$el) {
      plugin.installed = false
      document.body.removeChild($vm.$el)
      $vm = undefined
      if (Vue.$xyPlugins && Vue.$xyPlugins.noticeView) {
        Vue.$xyPlugins.noticeView = undefined
      }
    }
  }
}

export default plugin
export const install = plugin.install
export const uninstall = plugin.uninstall



// WEBPACK FOOTER //
// ./src/plugins/noticeView.js